import { gsap } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'
import { SplitText } from 'gsap/SplitText'
import { MathUtils } from 'three'
gsap.registerPlugin(CustomEase)
// CustomEase.create('cameraBounceBack', 'M0,0 C0,0 0.021,0.284 0.046,0.373 0.066,0.448 0.072,0.589 0.098,0.654 0.12,0.714 0.149,0.853 0.177,0.9 0.2,0.941 0.257,1.031 0.284,1.058 0.308,1.082 0.373,1.095 0.4,1.1 0.596,1.135 0.546,-0.189 0.706,-0.136 0.808,-0.101 0.835,-0.03 0.91,-0.002 0.979,0.010 1,0 1,0')
CustomEase.create('cameraBounceBack', 'M0,0 C0.03,0.28 0.07,0.81 0.28,1.06 0.67,1.38 0.5,-0.19 0.71,-0.14 0.82,-0.1 0.81,0.03 0.99,0 0.99333,0 0.99667,0 1,0 ')

const defaultSplitText = {
  // wordsClass: 'overflow-hidden',
  linesClass: 'overflow-hidden',
  tag: 'span'
}

export function fadeIn (el: HTMLElement, opts?: gsap.TweenVars) {
  return gsap.from(el, {
    opacity: 0,
    ease: 'none',
    duration: 0.3,
    stagger: 0.03,
    ...opts
  })
}

export function revealCharText (el: HTMLElement, opts?: gsap.TweenVars) {
  const splitted = new SplitText(el, { type: 'chars', ...defaultSplitText })
  const charsLength = splitted.chars?.length
  const duration = (opts?.duration as number) || charsLength * 0.167 || 1

  return gsap.from(splitted.chars, {
    data: { destroy: () => splitted.revert() },
    display: 'none',
    ease: 'power3.inOut',
    stagger: {
      amount: duration / 2,
      from: 'start'
    },
    ...opts,
    duration
  })
}

export function animateColorText (el: HTMLElement, opts?: gsap.TweenVars) {
  const splitted = new SplitText(el, { type: 'words', ...defaultSplitText })
  const duration = (opts?.duration as number) || 1

  return gsap.from(splitted.words, {
    data: { destroy: () => splitted.revert() },
    duration,
    color: 'black',
    ease: 'steps(1)',
    stagger: {
      amount: duration,
      from: 'start'
    },
    ...opts
  })
}

export function popup (target: gsap.TweenTarget, opts?: gsap.TweenVars) {
  return gsap.from(target, {
    scale: 0,
    opacity: 0,
    ease: 'power3.inOut',
    stagger: 0.03,
    ...opts
  })
}

export function slideUp (target: gsap.TweenTarget, opts?: gsap.TweenVars) {
  return gsap.from(target, {
    yPercent: 140,
    ease: 'power3.inOut',
    stagger: 0.03,
    ...opts
  })
}

export function scaleX (target: gsap.TweenTarget, opts?: gsap.TweenVars) {
  return gsap.from(target, {
    scaleX: 0,
    ease: 'power3.out',
    stagger: 0.03,
    ...opts
  })
}

export function scaleY (target: gsap.TweenTarget, opts?: gsap.TweenVars) {
  return gsap.from(target, {
    scaleY: 0,
    ease: 'power3.out',
    stagger: 0.03,
    ...opts
  })
}

export function revealText (el: HTMLElement, opts?: gsap.TweenVars) {
  const splitted = new SplitText(el, { type: 'lines, words', ...defaultSplitText })
  const duration = (opts?.duration as number) || 1

  return slideUp(splitted.words, {
    data: {
      destroy: () => {
        splitted?.revert()
        el.setAttribute('data-split-reverted', '')
      }
    },
    duration,
    ...opts
  })
}

gsap.registerEffect({
  name: 'blink',
  effect: (targets, config) => {
    const tl = gsap.timeline()
    tl.to(targets, {
      stagger: {
        each: 0.1,
        from: 'random'
      },
      keyframes: {
        value: [config.in ? 0 : 1, 1, 1, 1, 0, 0.4, 0, 0.4, 0, config.in ? 1 : 0],
        ease: 'power1.inOut'
      },
      duration: config.duration,
      ease: 'power2.in'
    })
    return tl
  },
  defaults: { duration: 0.65, in: true }, // defaults get applied to any "config" object passed to the effect
  extendTimeline: true // now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
})

gsap.registerEffect({
  name: 'objScale',
  effect: (targets, config) => {
    const tl = gsap.timeline()

    tl.fromTo(targets[0].scale, {
      x: 0, y: 0, z: 0
    }, {
      x: 1,
      y: 1,
      z: 1,
      duration: config.duration,
      ease: config.ease
    }, 0)
    tl.fromTo(targets[0].rotation, {
      x: () => MathUtils.degToRad(-20),
      y: () => MathUtils.degToRad(-90)
    }, {
      x: 0,
      y: 0,
      duration: config.duration + 0.25,
      ease: config.ease
    }, 0)
    return tl
  },
  defaults: { ease: 'power2.out', duration: 0.5 }, // defaults get applied to any "config" object passed to the effect
  extendTimeline: true // now you can call the effect directly on any GSAP timeline to have the result immediately inserted in the position you define (default is sequenced at the end)
})
